const timezoneInterceptorEnabled =
  process.env.REACT_APP_TZ_INTERCEPTOR_ENABLED === 'true';

export const formatDate = (date) => {
  if (!date) {
    return '';
  }

  if (timezoneInterceptorEnabled) {
    return date;
  }

  return new Date(date).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    timeZone: 'UTC'
  });
};
